import userManagement from '../apis/userManagement.api';
import { UserProject } from '../types/project.types';
import { AxiosResponse } from 'axios';
// import { AccessTokenService } from '@innovyze/lib_onu_forge';

const dummyData = [
	{
		id: '1',
		name: 'Project 1',
		sourceId: '11',
		hubRegion: 'America',
		teamName: 'Cool Team',
		hubName: 'Cool Hub',
		hubUrn: 'http://www.coolhub.com',
		createdOn: '12/04/1990',
		lastModifiedOn: '12/04/1990',
		imageUrl: 'http://www.coolhub.com/img.png',
		thumbnailImageUrl: 'http://www.coolhub.com/img-thumb.png',
		accessLevel: 'admin',
		status: 'active',
		userProducts: [
			{
				name: 'Insight',
				access: 'admin',
				url: 'http://app.info360.com',
			},
			{
				name: 'Model',
				access: 'admin',
				url: 'http://app.info360.com',
			},
		],
	},
	{
		id: '1',
		name: 'Project 1',
		sourceId: '11',
		hubRegion: 'APAC',
		teamName: 'Cool Team',
		hubName: 'Cool Hub',
		hubUrn: 'http://www.coolhub.com',
		createdOn: '12/04/1990',
		lastModifiedOn: '12/04/1990',
		imageUrl: 'http://www.coolhub.com/img.png',
		thumbnailImageUrl: 'http://www.coolhub.com/img-thumb.png',
		accessLevel: 'admin',
		status: 'active',
		userProducts: [
			{
				name: 'Model',
				access: 'admin',
				url: 'http://app.info360.com',
			},
		],
	},
	{
		id: '2',
		name: 'Project 2',
		sourceId: '22',
		hubRegion: 'America',
		teamName: 'Cool Team',
		hubName: 'Cool Hub',
		hubUrn: 'http://www.coolhub.com',
		createdOn: '12/04/1990',
		lastModifiedOn: '12/04/1990',
		imageUrl: 'http://www.coolhub.com/img.png',
		thumbnailImageUrl: 'http://www.coolhub.com/img-thumb.png',
		accessLevel: 'admin',
		status: 'active',
		userProducts: [
			{
				name: 'Insight',
				access: 'admin',
				url: 'http://app.info360.com',
			},
		],
	},
];

const mockResponse = {
	data: dummyData,
	status: 200,
	statusText: 'OK',
	headers: { 'content-type': 'application/json' },
	config: {
		method: 'get',
		url: '/api/data',
	},
	request: {},
};

interface QueryParamsProps {
	cursor?: string | null;
	limit?: number | null;
	searchText?: string | null;
	sortBy?: string | null;
	sortOrder?: 'asc' | 'desc' | null;
}

export const getProjects = (
	queryParams?: QueryParamsProps | null,
): Promise<AxiosResponse<UserProject[]>> => {
	// @ts-ignore
	// return new Promise(resolve => resolve(mockResponse));
	// const service = new AccessTokenService();
	// // {clientId: '', clientSecret: ''}
	// return service.getAccessToken();
	const payload = {
		includeProducts: true,
		pagination: {
			cursor: queryParams?.cursor ?? undefined,
			limit: queryParams?.limit ?? 20,
		},
		...(queryParams?.searchText || queryParams?.sortBy
			? {
					filterInput: {
						name: queryParams?.searchText ?? undefined,
						sortProperties: queryParams?.sortBy
							? {
									sortBy: queryParams.sortBy,
									sortOrder: queryParams.sortOrder ?? 'asc',
							  }
							: undefined,
					},
			  }
			: {}),
	};
	return userManagement.post('projects', payload);
};
